import { useContext } from "react";
import ClientsTable from "../../components/Tables/ClientsTable/ClientsTable";
import { Context } from "../../context/context";

export default function Clients() {
  const { sidebar } = useContext(Context);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Clientes</h1>
        <div className="table-container">
          <ClientsTable />
        </div>
      </main>
    </>
  );
}
